import http from './http'

export function getAssessments(params) {
  return http.get('/assessments/', { params })
}

export function getAssessment(id) {
  return http.get(`/assessments/${id}/`)
}

export function createAssessment(data) {
  return http.post('/assessments/', data)
}

export function cancelAssessment(id) {
  return http.post(`/assessments/${id}/cancel/`)
}

export function generateAssessmentSummary(id, targetType = 'visitor') {
  return http.post(
    `/assessments/${id}/generate_summary/`,
    { target_type: targetType },
    { meta: { toast: false } }
  )
}

export function getMyAiUsageSummary() {
  return http.get('/assessments/ai_usage/me/summary/')
}

export function getPublicAssessment(uid) {
  return http.get(`/assessments/public/${uid}/`)
}

export function submitPublicAssessment(uid, data) {
  return http.post(`/assessments/public/${uid}/`, data)
}
